import React from 'react';

const variants = {
  primary:   'bg-blue-700 text-white hover:bg-blue-800 border border-blue-700',
  secondary: 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50',
  danger:    'bg-red-50 border border-red-200 text-red-800 hover:bg-red-100',
  ghost:     'bg-transparent border border-transparent text-blue-700 hover:bg-blue-50',
  success:   'bg-green-50 border border-green-200 text-green-800 hover:bg-green-100',
  info:      'bg-blue-50 border border-blue-200 text-blue-800 hover:bg-blue-100',
};

const sizes = {
  sm: 'px-3 py-1.5 text-xs rounded-md gap-1.5',
  md: 'px-4 py-2 text-sm rounded-lg gap-2',
  lg: 'px-5 py-2.5 text-sm rounded-lg gap-2',
};

export function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  disabled = false,
  ...props
}) {
  return (
    <button
      disabled={disabled}
      className={`inline-flex items-center justify-center font-medium transition-colors
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1
        disabled:opacity-50 disabled:cursor-not-allowed
        ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
